const hostname = window && window.location && window.location.hostname
const prodHosts = ['hacksummit.org','hacksummit2018.firebaseapp.com']

export const config = {
  // prod and stage firebase keys
  firebase: 
    prodHosts.includes(hostname) ? {
      apiKey: "AIzaSyDj0SgFpFvy0cRSug8ILG3IksZWjNP6NHw",
      authDomain: "hacksummit2018.firebaseapp.com",
      databaseURL: "https://hacksummit2018.firebaseio.com",
      projectId: "hacksummit2018"
    } : {
      apiKey: "AIzaSyBxZzU_-UPkN3uuE7vgfHjqeOW22pC6KkE",
      authDomain: "hacksummit2018-stage.firebaseapp.com",
      databaseURL: "https://hacksummit2018-stage.firebaseio.com",
      projectId: "hacksummit2018-stage"
    },
  // prod and stage backend hostnames
  backend: prodHosts.includes(hostname) ? 'https://hacksummit-v2.herokuapp.com' : 'http://127.0.0.1:3001',
  // prod and stage Stripe keys
  stripeKey: prodHosts.includes(hostname) ? 'pk_live_YUgfGyaW0Flos3mzdzlO7t07' : 'pk_test_yE4qxm8mtrlOhQuXinIDB8Rf',
// prod and stage Crowdcast event urls
  crowdcast: prodHosts.includes(hostname) ? 'https://www.crowdcast.io/e/hacksummit-2018' : 'https://www.crowdcast.io/e/hacksummit-2018'
};


// WEBPACK FOOTER //
// ./src/config/index.js